



































































































































































































import ModulesHelper from '@core/services/modules.helper';
import { POSContact, POSProductTypeData, POSTicketDetail } from '@pos/interfaces/pos-v2';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-pos-print-ticket',
  components: {},
})
export default class PosPrintTicket extends Vue {
  @Prop({ type: Object, required: true }) readonly ticket: POSTicketDetail;
  @Prop({ type: Array, required: true }) readonly ticketProductTypes: POSProductTypeData[];
  @Prop({ type: String, required: true }) readonly cashierName: string;
  @Prop({ type: Object, required: true }) readonly contact: POSContact;
  @Prop({ type: Number, required: true }) readonly posSessionId: number;

  get readyToShow(): boolean {
    return !!this.ticket && !!this.contact;
  }

  //   FIXME: check if needed
  //   destroyed() {
  //     const el = document.body;
  //     // Do not print the ticket if POS checkout not opened
  //     el.classList.remove('pos-checkout-opened');
  //   }

  get isTaxManagementModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper.TAX_MANAGEMENT_MODULE_NAME);
  }

  get logo() {
    if (
      this.$store.getters['centerSettings/centerSettings'] &&
      this.$store.getters['centerSettings/centerSettings'].logo_url
    ) {
      let logo = this.$store.getters['centerSettings/centerSettings'].logo_url;
      if (typeof logo === 'string') {
        logo = JSON.parse(logo);
      }
      return logo.url;
    }
    return null;
  }
  get ticketHeader() {
    return this.$store.getters['centerSettings/centerSettings']
      ? this.$store.getters['centerSettings/centerSettings'].ticket_header
      : null;
  }
  get ticketFooter() {
    return this.$store.getters['centerSettings/centerSettings']
      ? this.$store.getters['centerSettings/centerSettings'].ticket_footer
      : null;
  }

  get paymentsSummary(): object {
    const payments = {};
    this.ticket?.payments
      ?.filter(payment => payment.status === 'paid')
      ?.forEach(item => {
        if (item.paid_amount < 0) {
          payments['returned'] = (payments['returned'] || 0) + item.paid_amount;
        } else {
          payments[item.payment_method_type] =
            (payments[item.payment_method_type] || 0) + item.paid_amount;
        }
      });
    return payments;
  }

  get totalPaidAmount(): string {
    let total = 0;
    this.ticket?.payments
      ?.filter(payment => payment.status === 'paid')
      ?.forEach(payment => {
        if (payment.paid_amount > 0) {
          total = total + payment.paid_amount;
        }
      });
    return total.toString();
  }

  get totalReturnedAmount(): string {
    let total = 0;
    this.ticket?.payments
      ?.filter(payment => payment.status === 'paid')
      ?.forEach(payment => {
        if (payment.paid_amount < 0) {
          total = total + payment.paid_amount;
        }
      });
    return total.toString();
  }

  get differentPaymentMethods() {
    return Object.keys(this.paymentsSummary).filter(item => item !== 'returned').length;
  }

  getTotalTaxExcluded(total, tax_rate) {
    return total / (1 + tax_rate / 100);
  }

  getTaxAmount(total, tax_rate) {
    return total - this.getTotalTaxExcluded(total, tax_rate);
  }

  formatAmount(value: string | number) {
    const emptyIfNull = false;
    const zeroIfNull = true;
    return this.$bpcHelper.formatPrice(value, emptyIfNull, zeroIfNull);
  }

  formatNumber(value: string | number) {
    const emptyIfNull = false;
    const zeroIfNull = true;
    return this.$bpcHelper.formatNumber(value, emptyIfNull, zeroIfNull);
  }

  get totalsByTaxRate() {
    const totalsByTaxRate: { [key: string]: number } = {};
    for (const productType of this.ticketProductTypes) {
      for (const product of productType.products) {
        if (!totalsByTaxRate[product.taxRate]) {
          totalsByTaxRate[product.taxRate] = 0;
        }
        totalsByTaxRate[product.taxRate] += product.total;
      }
    }
    return totalsByTaxRate;
  }
}
